import { REPORT_ROUTE_NAMES, ROUTE_NAMES } from '@/constant/routes'
import { requestReportUpgrade } from '@/business-logic/reportUpgradeRequest'

const PLAN_LOADED_TIMEOUT_MS = 8000

const isPlanLoaded = (state) => Object.keys(state.planBenefit || {}).length > 0

export const waitForPlanBenefit = (store, timeoutMs = PLAN_LOADED_TIMEOUT_MS) => new Promise((resolve) => {
  if (isPlanLoaded(store.state)) {
    resolve(true)
    return
  }
  let unwatch = null
  const timer = setTimeout(() => {
    if (unwatch) unwatch()
    resolve(false)
  }, timeoutMs)
  unwatch = store.watch(
    (state) => isPlanLoaded(state),
    (loaded) => {
      if (!loaded) return
      clearTimeout(timer)
      unwatch()
      resolve(true)
    },
  )
})

export const createReportRouteGuard = (store) => async (to, from, next) => {
  if (!REPORT_ROUTE_NAMES.includes(to.name)) {
    next()
    return
  }
  await store.dispatch('featureToggles/whenAuthFlagsReady')
  await waitForPlanBenefit(store)
  if (store.getters.canViewReport) {
    next()
    return
  }
  if (from?.name) {
    requestReportUpgrade()
    next(false)
    return
  }
  next({ name: ROUTE_NAMES.USER_PLAN, replace: true })
}
